import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { camelCase, get } from 'lodash'
import { compose } from 'redux'

import { Table, Button, Popconfirm, Divider, Row, Col } from 'antd'
import SearchBanner from './SearchBanner'
import { getBanners, deleteBanner } from '../../actions/bannerActions'
import { ROLE_TYPE } from '../../enums/enums';
import { withPermissions } from '../../utils/permissionsHoc'

class BannerList extends React.Component {

	columns = [
		{
			title: 'ID',
			dataIndex: 'id',
			key: 'id',
			sorter: true,
			sortDirections: ['ascend', 'descend']
		}, {
			title: 'Title',
			dataIndex: 'title',
			key: 'title',
			sorter: true,
			defaultSortOrder: 'ascend',
			sortDirections: ['ascend', 'descend']
		}, {
			title: 'Subtitle',
			dataIndex: 'subtitle',
			key: 'subtitle',
			sorter: true,
			sortDirections: ['ascend', 'descend']
		}, {
			title: 'Image',
			dataIndex: 'image',
			key: 'image',
			render: (text, banner) => {
				if(banner.image){
					return <img alt={get(banner, 'name')} style={{display: 'block', maxWidth: '180px', maxHeight: '70px', width: 'auto', height: 'auto'}} src={get(banner, 'image')}/>
				} else {
					return ''
				}
			}
		}, {
			title: 'Url',
			dataIndex: 'url',
			key: 'url',
			sorter: true,
			sortDirections: ['ascend', 'descend']
		}, {
			title: 'Brand',
			dataIndex: 'brand.name',
			key: 'brandsName',
			sorter: true,
			sortDirections: ['ascend', 'descend']
		}, {
			title: 'Languages',
			dataIndex: 'languages',
			key: 'laguages',
			sorter: false
		}, {
			title: 'Action',
			key: 'action',
			render: (text, banner) => {
				return this.props.totalBanners >= 1
					? (
						<span>
							<Link to={'/banners/update/' + banner.id}>Update</Link>
							<Divider type="vertical" />
							<Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(banner.id)}>
								<Link to={'#'}>Delete</Link>
							</Popconfirm>
						</span>
					) : null
			}
		}
	]

	componentDidMount() {
		this.props.getBanners(undefined, undefined, 'title:ascend', '')
	}

	handleDelete = (bannerID) => {
		this.props.deleteBanner(bannerID)
	}

	handleSearch = (value) => {
		this.props.getBanners(undefined, undefined, undefined, value.search)
	}
	
	handlePageChange = (page) => {
		this.props.getBanners(page, undefined, undefined, undefined)
	}

	handlePageSizeChange = (current, pageSize) => {
		this.props.getBanners(current, pageSize, undefined, undefined)
	}

	handleChange = (pagination, filters, sorter) => {
		// get correct format of sort parameter
		// exp. brandName:ascend
		const orderValue = `${camelCase(sorter.columnKey)}:${sorter.order}`

		if (sorter.field) {
			this.props.getBanners(pagination.current, pagination.pageSize, orderValue, undefined)
		} else {
			this.props.getBanners(pagination.current, pagination.pageSize, '', undefined)
		}
	}
  
	render() {
		const columns = this.columns
		const showTotalFunction = (total, range) => {
			return `${range[0]}-${range[1]} of ${total} items`
		}

		const { banners, actualPage, totalBanners, isLoading } = this.props
		const data = banners || null

		return (
			<div>
				<Row type="flex" align="middle" style={{ marginBottom: '10px' }}>
					<Col span={8}>
						<Button type="primary" htmlType="submit">
							<Link to='/banners/create'>Create banner</Link>
						</Button>
					</Col>
					<Col span={8} offset={8}>
						<SearchBanner/>
					</Col>
				</Row>

				<Row style={{ marginBottom: '10px' }}>
					<Table {...this.state} pagination={{
						showTotal: showTotalFunction,
						current: actualPage,
						total: totalBanners,
						showSizeChanger: true,
						onShowSizeChange: this.handlePageSizeChange
					}} columns={columns} dataSource={data} rowKey="id" loading={isLoading} onChange={this.handleChange} />
				</Row>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		banners: state.banner.list.data,
		isLoading: state.banner.list.isLoading,
		actualPage: state.banner.list.actualPage,
		totalBanners: state.banner.list.totalBanners,
		pageSize: state.banner.list.pageSize,
		pageSizes: state.banner.list.pageSizes
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		getBanners: (pageValue, pageSizeValue, orderValue, searchValue) => {
			dispatch(getBanners(pageValue, pageSizeValue, orderValue, searchValue))
		},
		deleteBanner: (bannerID) => {
			dispatch(deleteBanner(bannerID))
		}
	}
}

export default compose(
	withPermissions([ROLE_TYPE.ADMIN, ROLE_TYPE.MANAGER]),
	connect(mapStateToProps, mapDispatchToProps)
)(BannerList)
